<template>
<div class="content-i">
    <div class="content-box">

        <!--START - Recent Ticket Comments-->
        <div class="element-wrapper">
            <div class="element-actions d-none d-sm-block">
                <a class="btn btn-primary btn-sm" >
                    <i class="os-icon os-icon-ui-22"></i>
                    <router-link tag="span" :to="`/copydesk/imports/add`">
                        Add Import
                    </router-link>
                </a>
            </div>
            <h6 class="element-header">Copydesk Imports</h6>
            <div class="element-box-tp">
                <EmptyState v-if="!pagination.data" >
                    <div slot="empty_state_text">
                       There are no imports
                    </div>
                </EmptyState>
                <Loader v-if="isLoading == false" />
                <div class="table-responsive" v-else>
                    <table class="table table-padded">
                        <thead>
                            <tr>
                                <th>Import Code</th>
                                <th>Requested By</th>
                                <th>Import Type</th>
                                <th>Context</th>
                                <th>Import Date</th>
                                <th>Import Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="report in pagination.data">
                                <td>{{report.code}}</td>
                                <td>
                                    <div class="user-with-avatar"><img alt="" :src="report.avatar"><span>{{report.name}}</span></div>
                                </td>
                                <td>
                                    <div class="capitalize">{{report.import_type && report.import_type.replace(/_/g, ' ')}}</div>
                                </td>
                                <td>
                                    <div class="capitalize" v-for="value, key in JSON.parse(report.context)" >
                                        {{key}}: {{value}}
                                    </div>
                                </td>
                                <td><span>{{report.created_at}}</span></td>
                                <td class="nowrap">
                                    <div v-html="formatReportStatus(report)"></div>
                                    <a class="btn btn-primary btn-sm" v-if="report.id_copydesk_session">
                                        <router-link tag="span" :to="`/copydesk/sessions/write/${report.id_copydesk_session}`">
                                            View Session
                                        </router-link>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getExportedReports()" :offset="5"></Pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

export default {
  components: {
    Pagination,
    EmptyState,
    Loader
  },
  data: function () {
    return {
      isLoading: true,
      pagination: {
        'current_page': 1
      }
    }
  },
  mounted: function () {
    var self = this
    this.getExportedReports()
    var channel = this.$pusher.subscribe('export')
    channel.bind('complete', function (data) {
      self.getExportedReports()
    })
  },
  methods: {
    getExportedReports: function () {
      var self = this
      const url = '/copydesk/io?page=' + this.pagination.current_page
      self.isLoading = true
      this.$http.get(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          console.log(response)
          self.pagination = response.data
          self.isLoading = true
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = true
        })
    },
    formatReportStatus: function (report) {
      var response = ''
      if (report.status == 0) {
        response = '<span class="status-pill smaller yellow"></span><span>Queued</span>'
      } else if (report.status == 1) {
        response = '<div class="loader12"></div>'
      } else {
        response = '<span class="status-pill smaller green"></span><span>Processed</span>'
      }

      return response
    }
  }
}
</script>
